import { format, parse } from 'date-fns'

import {
  actionAlertHandler,
  actionStyles,
  CHECK_CLIENT_ELIGIBILITY,
  GET_CLIENT,
  GET_CLIENT_SESSION,
  GET_CLIENTS,
} from '../../common/constants/reduxConstants'
import { getClientData, getClientsData, getClientSessionData } from '../../common/http/data/clients'

export const getClients = (providerId?: string) => {
  const request = getClientsData(providerId)

  return (dispatch: any) => {
    return new Promise(function (resolve, reject) {
      request.then(
        (clientsReturn) => {
          dispatch({
            type: GET_CLIENTS,
            payload: clientsReturn,
          })

          resolve(clientsReturn)
        },
        (error) => {
          actionAlertHandler({
            actionStyle: actionStyles.ERROR,
            message: error,
            dispatch,
            expires: true,
            action: GET_CLIENTS,
          })
          reject(error)
        },
      )
    })
  }
}

export const getClient = (values: any, cancelToken: any, providerId?: string) => {
  const data: Record<string, string> = {
    full_name: encodeURIComponent(values.first_name + ' ' + values.last_name),
    dob: format(parse(values.dob, 'MM/dd/yyyy', new Date()), 'yyyy-MM-dd'),
  }

  const formData = new FormData()
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key])
  })
  const request = getClientData(formData, cancelToken, providerId)

  return {
    type: GET_CLIENT,
    payload: request,
  }
}

export const getClientSession = (lyraIds: string[], searchYear: number) => {
  const data = {
    lyra_id_list: lyraIds,
    searchYear: searchYear,
  }
  const response = getClientSessionData(data)

  return (dispatch: any) => {
    return new Promise(function (resolve, reject) {
      response.then(
        (clientsReturn) => {
          dispatch({
            type: GET_CLIENT_SESSION,
            payload: clientsReturn,
          })

          resolve(clientsReturn)
        },
        (error) => {
          actionAlertHandler({
            actionStyle: actionStyles.ERROR,
            message: error,
            dispatch,
            action: GET_CLIENT_SESSION,
            expires: true,
          })
          reject(error)
        },
      )
    })
  }
}

export const resendOutcomeEmail = (clientID: any, providerId?: string) => ({
  action: 'RESENT_OUTCOME_EMAIL',

  request: {
    method: 'get',
    url: `v1/outcomes/resend/${clientID}`,
    params: providerId && { providerId },
  },
})

export const checkClientEligibility = (data: any) => ({
  action: CHECK_CLIENT_ELIGIBILITY,

  request: {
    method: 'post',
    url: '/v1/eligibility-checker',
    data,
  },
})
